
import React from 'react';
import { Button } from '@/components/ui/button';
import { Zap, Target, Brain } from 'lucide-react';

const AILeadEngineHero = () => {
  return (
    <section className="relative bg-gradient-to-br from-brand-lightBlue via-white to-brand-gray overflow-hidden">
      {/* Background decoration */}
      <div className="absolute inset-0 bg-[url('/placeholder.svg')] opacity-5"></div>
      
      <div className="relative container mx-auto px-4 py-16 lg:py-24">
        <div className="max-w-4xl mx-auto text-center">
          {/* Beta Badge */}
          <div className="inline-flex items-center px-4 py-2 bg-brand-red/10 text-brand-red rounded-full text-sm font-medium mb-8 animate-fade-in">
            <span className="w-2 h-2 bg-brand-red rounded-full mr-2 animate-pulse"></span>
            BETA Programma - Beperkte Toegang
          </div>

          {/* Main Title */}
          <h1 className="text-4xl md:text-6xl font-bold text-gray-900 mb-8 leading-tight">
            AI Lead Engine (BETA):
            <span className="block text-brand-blue">de toekomst van B2B prospectie</span>
          </h1>

          {/* Subtitle */}
          <p className="text-xl md:text-2xl text-gray-700 mb-12 max-w-3xl mx-auto font-medium">
            Meer afspraken. Minder koud bellen. Slimmere sales.
          </p>

          {/* Key Benefits */}
          <div className="flex flex-wrap justify-center gap-6 lg:gap-8 mb-16">
            <div className="flex items-center text-gray-700 bg-white/70 px-6 py-3 rounded-full shadow-sm">
              <Target className="h-5 w-5 text-brand-blue mr-2" />
              <span className="font-medium">10x minder manuele opvolging</span>
            </div>
            <div className="flex items-center text-gray-700 bg-white/70 px-6 py-3 rounded-full shadow-sm">
              <Brain className="h-5 w-5 text-brand-blue mr-2" />
              <span className="font-medium">5x meer output</span>
            </div>
            <div className="flex items-center text-gray-700 bg-white/70 px-6 py-3 rounded-full shadow-sm">
              <Zap className="h-5 w-5 text-brand-blue mr-2" />
              <span className="font-medium">100% warme leads</span>
            </div>
          </div>

          {/* Primary CTA */}
          <Button 
            size="xl" 
            variant="highlight" 
            className="text-lg px-8 py-4 shadow-lg hover:shadow-xl transition-all transform hover:scale-105 mb-6"
            scrollToId="beta-form"
          >
            <Zap className="mr-2 h-5 w-5" />
            Vraag toegang tot de BETA
          </Button>

          {/* Trust indicators */}
          <p className="text-sm text-gray-600">
            ✓ GDPR-conform • ✓ Volledig transparant • ✓ 100% menselijk gestuurd
          </p>
        </div>
      </div>
    </section>
  );
};

export default AILeadEngineHero;
